import {create} from "zustand";

const useWorkspaceStore = create((set) => ({
    isWorkspaceUpdated: false,

    setWorkspaceUpdated: (status) => set({isWorkspaceUpdated: status}),
}));

export default useWorkspaceStore